'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _defaultPropTypes = require('./defaultPropTypes');

var _defaultPropTypes2 = _interopRequireDefault(_defaultPropTypes);

var _stackedNotification = require('./stackedNotification');

var _stackedNotification2 = _interopRequireDefault(_stackedNotification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The notification list does not have any state, so use a
 * pure function here. It just needs to return the stacked array
 * of notification components.
 */
var NotificationStack = function NotificationStack(props) {
  return _react2.default.createElement(
    'div',
    { className: 'notification-list' },
    props.notifications.map(function (notification, index) {
      var dismissAfter = notification.dismissAfter || props.dismissAfter;
      var isLast = index === 0 && props.notifications.length === 1;

      return _react2.default.createElement(_stackedNotification2.default, _extends({}, notification, {
        key: notification.key,
        isLast: isLast,
        action: notification.action || props.action,
        dismissAfter: isLast ? dismissAfter : dismissAfter + index * 1000,
        onDismiss: props.onDismiss.bind(undefined, notification),
        index: index
      }));
    })
  );
};

NotificationStack.propTypes = {
  notifications: _react.PropTypes.array.isRequired,
  onDismiss: _react.PropTypes.func.isRequired
};

NotificationStack.defaultProps = {
  dismissAfter: 1000
};

exports.default = NotificationStack;


//////////////////
// WEBPACK FOOTER
// ./~/react-notification/dist/notificationStack.js
// module id = 1930
// module chunks = 0